"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coppaDataHandler = exports.gppConsentHandler = exports.gdprConsentHandler = exports.uspConsentHandler = exports.allConsentHandler = void 0;
var log_1 = require("../../utils/log");
var UspConsentHandler_1 = require("./UspConsentHandler");
var GdprConsentHandler_1 = require("./GdprConsentHandler");
var GppConsentHandler_1 = require("./GppConsentHandler");
var index_1 = require("../../index");
var AllConsentHandler = /** @class */ (function () {
    function AllConsentHandler() {
        this._ready = false;
        this._timeout = null;
        this._timeoutHandler = null;
        this._should_cancel_auction = true;
        this.cmd = [];
        this.allHandlers = {
            gdpr: new GdprConsentHandler_1.GdprConsentHandler(),
            usp: new UspConsentHandler_1.UspConsentHandler(),
            gpp: new GppConsentHandler_1.GppConsentHandler()
        };
    }
    AllConsentHandler.prototype.initAllHandlers = function () {
        var _this = this;
        this._timeout = 5500;
        for (var handler in this.allHandlers) {
            this.allHandlers[handler].init();
        }
        this._timeoutHandler = setTimeout(function () {
            (0, log_1.logInfo)("All Consent Handlers Timed Out GPP, GDPR, USPC");
            _this.continueExecution();
        }, this._timeout);
    };
    AllConsentHandler.prototype.setHandlerReady = function () {
        if (this.checkAllHandlersReady()) {
            (0, log_1.logInfo)("All Handlers Ready");
            this.continueExecution();
        }
    };
    AllConsentHandler.prototype.checkAllHandlersReady = function () {
        var ready = true;
        // loop though this.allHandlers
        for (var handler in this.allHandlers) {
            // check if handler is ready
            if (!this.allHandlers[handler].done) {
                return ready = false;
            }
        }
        return ready;
    };
    AllConsentHandler.prototype.checkIfMissingConsent = function () {
        var missing = false;
        // loop though this.allHandlers
        for (var handler in this.allHandlers) {
            // check if handler is ready
            if (this.allHandlers[handler].missing_consent) {
                return missing = true;
            }
        }
        return missing;
    };
    AllConsentHandler.prototype.continueExecution = function () {
        var _this = this;
        if (this._timeoutHandler !== null) {
            clearTimeout(this._timeoutHandler);
            this._timeoutHandler = null;
        }
        if (!this._ready) {
            // Check if missing consent
            this._should_cancel_auction = this.checkIfMissingConsent();
            // Set ready flag
            this._ready = true;
            // Execute all commands in the queue
            this.cmd.forEach(function (fn) {
                fn.call(_this);
            });
            // Replace the queue with a function that executes commands immediately
            this.cmd.push = function (fn) {
                fn.call(_this);
                return 1;
            };
        }
    };
    AllConsentHandler.prototype.checkIfMissing = function () {
        var missing = false;
        if (this._should_cancel_auction) {
            for (var handler in this.allHandlers) {
                if (this.allHandlers[handler].checkIfMissing()) {
                    return missing = true;
                }
            }
        }
        return missing;
    };
    AllConsentHandler.prototype.loadIfMissing = function (cb) {
        var cancel_auction = false;
        for (var handler in this.allHandlers) {
            if (this.allHandlers[handler].missing_consent) {
                this.allHandlers[handler].loadIfMissing(function (shouldCancelAuction, errMsg) {
                    var extraArgs = [];
                    for (var _i = 2; _i < arguments.length; _i++) {
                        extraArgs[_i - 2] = arguments[_i];
                    }
                    if (shouldCancelAuction) {
                        cancel_auction = true;
                        log_1.logInfo.apply(void 0, __spreadArray(["Canceling Auction", errMsg], extraArgs, false));
                        return;
                    }
                });
            }
        }
        if (!cancel_auction) {
            cb();
        }
        return true;
    };
    AllConsentHandler.prototype.isActivityAllowed = function (activity, params) {
        return this.allHandlers.gpp.isActivityAllowed(activity) &&
            this.allHandlers.gdpr.isActivityAllowed(activity, params);
    };
    return AllConsentHandler;
}());
exports.allConsentHandler = new AllConsentHandler();
exports.uspConsentHandler = exports.allConsentHandler.allHandlers.usp;
exports.gdprConsentHandler = exports.allConsentHandler.allHandlers.gdpr;
exports.gppConsentHandler = exports.allConsentHandler.allHandlers.gpp;
exports.coppaDataHandler = (function () {
    function getCoppa() {
        return !!(index_1.globalSettings.coppa);
    }
    return {
        getCoppa: getCoppa,
        getConsentData: getCoppa,
        getConsentMeta: getCoppa,
    };
})();
exports.allConsentHandler.initAllHandlers();
